export default "__VITE_ASSET__D8NPE7Lc__"